import { UseCase } from './UseCase';
import { InterfaceView } from '../entities/InterfaceView';
import { NavigateEvent } from '../events/navigateEvent/NavigateEvent';
export class ApplicationStartUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.event.sentEvent(new NavigateEvent(InterfaceView.MAIN_MENU));
    }
}
